import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useRef,
  useCallback,
} from "react";
import {
  CFormLabel,
  CFormInput,
  CFormSelect,
  CTooltip,
  CForm,
  CContainer,
  CRow,
  CCol,
  CFormCheck,
  CButton,
  CSpinner,
} from "@coreui/react";
import axios from "axios";
import PropTypes from "prop-types";

const ObjectInfoTab = forwardRef(
  (
    {
      initialObjectId,
      initialObjectType,
      availableObjectTypes,
      onSave,
      customerId,
      selectedObjectTypeFromModal,
    },
    ref,
  ) => {
    // --- НОВОЕ: Настройки видимости полей ---
    const [fieldSettings, setFieldSettings] = useState({});
    const [loadingSettings, setLoadingSettings] = useState(true);

    // Выводим данные из API в консоль
    console.log("Данные типов сооружений из API:", availableObjectTypes);
    console.log("Полученные props:", {
      initialObjectId,
      initialObjectType,
      availableObjectTypesCount: availableObjectTypes?.length,
      customerId,
      selectedObjectTypeFromModal,
    });

    // ID объекта теперь инициализируется как "Новый объект" при первом монтировании
    const [objectIdValue, setObjectIdValue] = useState(initialObjectId || "");
    const [objectIndexValue, setObjectIndexValue] = useState("");
    const [selectedObjectType, setSelectedObjectType] = useState(
      initialObjectType || "",
    );
    const [objectNameValue, setObjectNameValue] = useState(""); // Поле "Объект" - отдельно от ID объекта
    const [regions, setRegions] = useState([]);
    const [owners, setOwners] = useState([]);
    const [designers, setDesigners] = useState([]);
    const [works, setWorks] = useState([]);
    const [constructionOrgs, setConstructionOrgs] = useState([]);
    const [selectedRegion, setSelectedRegion] = useState("");
    const [selectedOwner, setSelectedOwner] = useState("");
    const [selectedDesigner, setSelectedDesigner] = useState("");
    const [selectedWork, setSelectedWork] = useState("");
    const [selectedOwnershipForm, setSelectedOwnershipForm] = useState("");
    const [selectedPurpose, setSelectedPurpose] = useState("");
    const [addressValue, setAddressValue] = useState("");
    const [buildYearValue, setBuildYearValue] = useState("");
    const [inputExpDateValue, setInputExpDateValue] = useState("");
    const [projectTypeValue, setProjectTypeValue] = useState("");
    const [selectedConstructionOrgs, setSelectedConstructionOrgs] = useState(
      [],
    );
    const [repairYearValue, setRepairYearValue] = useState("");
    const [cipherValue, setCipherValue] = useState("");
    const [workNameValue, setWorkNameValue] = useState("объект:");
    const [baseLinkValue, setBaseLinkValue] = useState("");
    const [workDirValue, setWorkDirValue] = useState("");
    const [stateObjValue, setStateObjValue] = useState("");
    const [periodToneValue, setPeriodToneValue] = useState("");
    const [floorsNumValue, setFloorsNumValue] = useState("");
    const [conditionalDesignationValue, setConditionalDesignationValue] =
      useState("");
    const [regNumberValue, setRegNumberValue] = useState("");
    const [constructiveSchemeValue, setConstructiveSchemeValue] = useState("");
    const [heightValue, setHeightValue] = useState("100");
    const [voltageValue, setVoltageValue] = useState("100");

    // Добавлено: LType - тип сооружения (id из таблицы) - теперь это будет ObjectCType
    const [lTypeValue, setLTypeValue] = useState("");
    // Добавлено: NTypeObj - теперь сюда будет подставляться ObjectType типа сооружения
    const [nTypeObjValue, setNTypeObjValue] = useState("");
    // Добавлено: idSurvOrg - всегда 3
    const [idSurvOrgValue, setIdSurvOrgValue] = useState(3);

    // Состояние для загрузки пути к папке
    const [isGeneratingWorkdir, setIsGeneratingWorkdir] = useState(false);
    const [workdirError, setWorkdirError] = useState("");

    // Добавленные состояния для недостающих полей
    const [markValue, setMarkValue] = useState("");
    const [pageNumberValue, setPageNumberValue] = useState("");
    const [yearValue, setYearValue] = useState("");
    const [survReasonValue, setSurvReasonValue] = useState("");
    const [nTypeRatingValue, setNTypeRatingValue] = useState("");
    const [idSpecWorkValue, setIdSpecWorkValue] = useState("");
    const [idSpecCheckValue, setIdSpecCheckValue] = useState("");
    const [idSpecControlValue, setIdSpecControlValue] = useState("");
    const [bookNameValue, setBookNameValue] = useState("");
    const [nTypeSubObjValue, setNTypeSubObjValue] = useState("");
    const [idTargetTaskValue, setIdTargetTaskValue] = useState("");
    const [dateSurvValue, setDateSurvValue] = useState("");
    const [idStateValue, setIdStateValue] = useState("");
    const [idDesignSchemaValue, setIdDesignSchemaValue] = useState("");
    const [idDocTypeValue, setIdDocTypeValue] = useState("");
    const [idSpecWorkSheetValue, setIdSpecWorkSheetValue] = useState("");
    const [idSpecWorkPhotoValue, setIdSpecWorkPhotoValue] = useState("");
    const [idSpecBuildValue, setIdSpecBuildValue] = useState("");
    const [idSpecTechValue, setIdSpecTechValue] = useState("");
    const [idSpecJournalValue, setIdSpecJournalValue] = useState("");
    const [eqInstallValue, setEqInstallValue] = useState("");
    const [heightTextValue, setHeightTextValue] = useState("");
    const [isDocAnalyseNot2Value, setIsDocAnalyseNot2Value] = useState("");
    const [coordLatValue, setCoordLatValue] = useState("");
    const [coordLngValue, setCoordLngValue] = useState("");
    const [degLatValue, setDegLatValue] = useState("");
    const [degLngValue, setDegLngValue] = useState("");
    const [idBuildOrgValue, setIdBuildOrgValue] = useState("");
    const [conditionOperValue, setConditionOperValue] = useState("");
    const [
      isMeasuringVerifyOutToReportValue,
      setIsMeasuringVerifyOutToReportValue,
    ] = useState("");
    const [idStateConclusionValue, setIdStateConclusionValue] = useState("");
    const [mSortPlanGraphValue, setMSortPlanGraphValue] = useState("");
    const [isDateSurvValue, setIsDateSurvValue] = useState("");
    const [dateSignConclusionValue, setDateSignConclusionValue] = useState("");
    const [isNotOutCategoryValue, setIsNotOutCategoryValue] = useState("");
    const [idSigner1Value, setIdSigner1Value] = useState("");
    const [idSigner2Value, setIdSigner2Value] = useState("");
    const [landImageValue, setLandImageValue] = useState("");
    const [isLandingValue, setIsLandingValue] = useState("");
    const [landNameValue, setLandNameValue] = useState("");
    const [lhPointValue, setLhPointValue] = useState("");
    const [rdPointValue, setRdPointValue] = useState("");
    const [isPreCategoryValue, setIsPreCategoryValue] = useState("");
    const [dateSurvNextValue, setDateSurvNextValue] = useState("");
    const [treeGroupNameValue, setTreeGroupNameValue] = useState("");
    const [isDeleteValue, setIsDeleteValue] = useState("");

    const [loadingRegions, setLoadingRegions] = useState(false);
    const [loadingOwners, setLoadingOwners] = useState(false);
    const [loadingDesigners, setLoadingDesigners] = useState(false);
    const [loadingWorks, setLoadingWorks] = useState(false);
    const [loadingConstructionOrgs, setLoadingConstructionOrgs] =
      useState(false);
    const [showConstructionOrgPicker, setShowConstructionOrgPicker] =
      useState(false);
    const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });
    const [regNumberLoading, setRegNumberLoading] = useState(false);
    const MAX_NAME_LENGTH = 20;
    const [objectIdError, setObjectIdError] = useState("");
    const inputRef = useRef(null);
    const pickerRef = useRef(null);

    const token = localStorage.getItem("token");

    // --- НОВОЕ: Загрузка настроек организации пользователя ---
    useEffect(() => {
      const fetchSettings = async () => {
        try {
          setLoadingSettings(true);
          const response = await axios.get("/api/auth/permissions/", {
            headers: { Authorization: `Bearer ${token}` },
          });

          // Получаем организацию из профиля. Если это админ, он может не иметь профиля или организации,
          // тогда разрешаем всё по умолчанию.
          const orgData = response.data.profile?.organization || {};
          const isAdmin = response.data.permissions?.is_admin || false;

          if (isAdmin) {
            // Для админа включаем все show_ поля принудительно
            const allVisible = {};
            Object.keys(orgData).forEach((key) => {
              if (key.startsWith("show_")) allVisible[key] = true;
            });
            // Если orgData пустая (у суперпользователя нет организации),
            // на фронте мы просто будем проверять наличие ключа.
            // В коде ниже я добавлю проверку на isAdmin.
            setFieldSettings({ ...allVisible, isAdmin });
          } else {
            setFieldSettings(orgData);
          }
        } catch (error) {
          console.error("Ошибка при получении настроек полей:", error);
        } finally {
          setLoadingSettings(false);
        }
      };

      if (token) fetchSettings();
    }, [token]);

    // Эффект для установки названия объекта из модального окна
    useEffect(() => {
      if (selectedObjectTypeFromModal) {
        console.log(
          "Получены данные из модального окна:",
          selectedObjectTypeFromModal,
        );
        setObjectNameValue(selectedObjectTypeFromModal.ObjectName || "");
        // Устанавливаем LType как ObjectCType, а NTypeObj как ObjectType
        setLTypeValue(
          selectedObjectTypeFromModal.ObjectCType?.toString() || "",
        );
        setNTypeObjValue(
          selectedObjectTypeFromModal.ObjectType?.toString() || "",
        );
      }
    }, [selectedObjectTypeFromModal]);

    // Эффект для установки LType и NTypeObj при изменении selectedObjectType
    useEffect(() => {
      if (selectedObjectType) {
        const type = availableObjectTypes.find(
          (t) => t.ObjectID.toString() === selectedObjectType,
        );
        console.log("Выбранный тип сооружения:", type);
        if (type) {
          // LType теперь берется из ObjectCType
          setLTypeValue(type.ObjectCType?.toString() || "");
          // NTypeObj теперь берется из ObjectType
          setNTypeObjValue(type.ObjectType?.toString() || "");
          // Также обновляем название объекта
          setObjectNameValue(type.ObjectName);
        }
      }
    }, [selectedObjectType, availableObjectTypes]);

    // Функция для получения года из регистрационного номера
    const extractYearFromRegNumber = (regNumber) => {
      if (!regNumber) return null;

      // Ищем паттерны года: 4 цифры подряд
      const yearMatch = regNumber.match(/\b(20\d{2})\b/);
      if (yearMatch) {
        return yearMatch[1];
      }

      // Ищем год после точки: .2025.
      const dotMatch = regNumber.match(/\.(\d{4})\./);
      if (dotMatch) {
        return dotMatch[1];
      }

      // Берем текущий год как fallback
      return new Date().getFullYear().toString();
    };

    // Функция для получения пути к папке из API
    const generateWorkdirPath = useCallback(async () => {
      if (!customerId || !objectIdValue || !token) {
        setWorkdirError("Недостаточно данных для генерации пути");
        return;
      }

      setIsGeneratingWorkdir(true);
      setWorkdirError("");

      try {
        // Извлекаем год из регистрационного номера
        const year =
          extractYearFromRegNumber(regNumberValue) ||
          new Date().getFullYear().toString();

        console.log("Генерация пути с параметрами:", {
          customerId,
          year,
          object_name: objectIdValue,
        });

        const response = await axios.get(
          "/api/objects/line-list/customer-workdir/",
          {
            params: {
              customer_id: customerId,
              year: year,
              object_name: objectIdValue,
            },
            headers: { Authorization: `Bearer ${token}` },
          },
        );

        console.log("Ответ от API для генерации пути:", response.data);

        if (response.data && response.data.workdir) {
          setWorkDirValue(response.data.workdir);
        } else {
          throw new Error("Путь не был сгенерирован");
        }
      } catch (error) {
        console.error("Ошибка при генерации пути:", error);
        setWorkdirError(
          error.response?.data?.error ||
            error.message ||
            "Ошибка генерации пути",
        );

        // Fallback: создаем путь вручную, используя objectIdValue
        const year =
          extractYearFromRegNumber(regNumberValue) ||
          new Date().getFullYear().toString();
        const fallbackPath = `\\\\192.168.0.2\\Data\\Текущие объекты\\Заказчик_${customerId}\\${year}\\${objectIdValue}`;
        setWorkDirValue(fallbackPath);
      } finally {
        setIsGeneratingWorkdir(false);
      }
    }, [customerId, objectIdValue, regNumberValue, token]);

    // Автоматически генерируем путь при изменении ID объекта или регистрационного номера
    useEffect(() => {
      if (customerId && objectIdValue && regNumberValue) {
        generateWorkdirPath();
      }
    }, [customerId, objectIdValue, regNumberValue, generateWorkdirPath]);

    // Закрытие по клику вне
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          showConstructionOrgPicker &&
          inputRef.current &&
          !inputRef.current.contains(event.target) &&
          pickerRef.current &&
          !pickerRef.current.contains(event.target)
        ) {
          setShowConstructionOrgPicker(false);
        }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [showConstructionOrgPicker]);

    // Позиционирование окошка
    useEffect(() => {
      if (showConstructionOrgPicker && inputRef.current) {
        const rect = inputRef.current.getBoundingClientRect();
        setPickerPosition({
          top: rect.bottom + window.scrollY,
          left: rect.left + window.scrollX,
        });
      }
    }, [showConstructionOrgPicker]);

    // Функция для получения регистрационного номера
    const fetchRegistrationNumber = useCallback(async () => {
      if (!token) return;

      setRegNumberLoading(true);
      try {
        const response = await axios.get(
          "/api/objects/line-list/registration-number/",
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );
        console.log("Регистрационный номер из API:", response.data);
        if (response.data?.registration_number) {
          setRegNumberValue(response.data.registration_number);
        }
      } catch (error) {
        console.error("Ошибка получения регистрационного номера:", error);
        setRegNumberLoading(false);
      }
    }, [token]);

    // Получаем регистрационный номер при монтировании и при изменении customerId
    useEffect(() => {
      fetchRegistrationNumber();
    }, [fetchRegistrationNumber, customerId]);

    // === Загрузка данных ===
    const fetchData = async (ntype, setter, setLoading) => {
      setLoading(true);
      try {
        const response = await axios.get(`/api/typetable/?ntype=${ntype}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = Array.isArray(response.data) ? response.data : [];
        console.log(`Данные для ntype=${ntype}:`, data);
        const sorted = data.sort((a, b) =>
          a.Name.localeCompare(b.Name, undefined, { sensitivity: "base" }),
        );
        setter(sorted);
      } catch (error) {
        console.error(`Ошибка загрузки данных для ntype=${ntype}:`, error);
        setter([]);
      } finally {
        setLoading(false);
      }
    };

    useEffect(() => {
      if (token) {
        fetchData(86, setRegions, setLoadingRegions);
        fetchData(64, setOwners, setLoadingOwners);
        fetchData(49, setDesigners, setLoadingDesigners);
        fetchData(67, setWorks, setLoadingWorks);
        fetchData(69, setConstructionOrgs, setLoadingConstructionOrgs);
      }
    }, [token]);

    useEffect(() => {
      if (initialObjectType && availableObjectTypes.length > 0) {
        setSelectedObjectType(initialObjectType);
      }
    }, [initialObjectType, availableObjectTypes]);

    // Обработчики основных полей
    const handleObjectIdChange = (e) => {
      const value = e.target.value;
      const cleanedValue = value.replace(/[^a-zA-Zа-яА-Я0-9]/g, "");

      if (value !== cleanedValue) {
        setObjectIdError("Разрешены только буквы и цифры");

        setObjectIdValue(cleanedValue.slice(0, MAX_NAME_LENGTH));
        return;
      }

      if (value.length > MAX_NAME_LENGTH) {
        setObjectIdError("Максимум 20 символов");
      } else {
        setObjectIdError("");
      }

      setObjectIdValue(value.slice(0, MAX_NAME_LENGTH));
    };

    const handleObjectIndexChange = (e) => setObjectIndexValue(e.target.value);
    const handleObjectTypeChange = (e) => {
      setSelectedObjectType(e.target.value);
    };

    // Поле "Объект" только для чтения, его значение берется из типа объекта
    const handleObjectNameChange = (e) => {
      setObjectNameValue(e.target.value);
    };

    const handleRegionChange = (e) => setSelectedRegion(e.target.value);
    const handleOwnerChange = (e) => setSelectedOwner(e.target.value);
    const handleDesignerChange = (e) => setSelectedDesigner(e.target.value);
    const handleWorkChange = (e) => {
      const workId = e.target.value;
      setSelectedWork(workId);
      setWorkNameValue("объект:");
      // Получаем наименование выбранной работы
      const selectedWorkObj = works.find((w) => w.Id.toString() === workId);
      if (selectedWorkObj) {
        setWorkNameValue(selectedWorkObj.Name);
      }
    };
    const handleOwnershipFormChange = (e) =>
      setSelectedOwnershipForm(e.target.value);
    const handlePurposeChange = (e) => setSelectedPurpose(e.target.value);
    const handleAddressChange = (e) => setAddressValue(e.target.value);
    const handleBuildYearChange = (e) => setBuildYearValue(e.target.value);
    const handleInputExpDateChange = (e) =>
      setInputExpDateValue(e.target.value);
    const handleProjectTypeChange = (e) => setProjectTypeValue(e.target.value);
    const handleRepairYearChange = (e) => setRepairYearValue(e.target.value);
    const handleCipherChange = (e) => setCipherValue(e.target.value);
    const handleWorkNameChange = (e) => setWorkNameValue(e.target.value);
    const handleBaseLinkChange = (e) => setBaseLinkValue(e.target.value);
    const handleStateObjChange = (e) => setStateObjValue(e.target.value);
    const handlePeriodToneChange = (e) => setPeriodToneValue(e.target.value);
    const handleFloorsNumChange = (e) => setFloorsNumValue(e.target.value);
    const handleConditionalDesignationChange = (e) =>
      setConditionalDesignationValue(e.target.value);
    const handleRegNumberChange = (e) => setRegNumberValue(e.target.value);
    const handleConstructiveSchemeChange = (e) =>
      setConstructiveSchemeValue(e.target.value);
    const handleHeightChange = (e) => setHeightValue(e.target.value);
    const handleVoltageChange = (e) => setVoltageValue(e.target.value);

    // Обработчики для новых полей
    const handleMarkChange = (e) => setMarkValue(e.target.value);
    const handlePageNumberChange = (e) => setPageNumberValue(e.target.value);
    const handleYearChange = (e) => setYearValue(e.target.value);
    const handleSurvReasonChange = (e) => setSurvReasonValue(e.target.value);
    // idSurvOrg всегда равен 3, не меняем
    const handleIdSurvOrgChange = (e) => setIdSurvOrgValue(3);
    const handleNTypeRatingChange = (e) => setNTypeRatingValue(e.target.value);
    const handleNTypeObjChange = (e) => setNTypeObjValue(e.target.value);
    const handleIdSpecWorkChange = (e) => setIdSpecWorkValue(e.target.value);
    const handleIdSpecCheckChange = (e) => setIdSpecCheckValue(e.target.value);
    const handleIdSpecControlChange = (e) =>
      setIdSpecControlValue(e.target.value);
    const handleBookNameChange = (e) => setBookNameValue(e.target.value);
    const handleNTypeSubObjChange = (e) => setNTypeSubObjValue(e.target.value);
    const handleIdTargetTaskChange = (e) =>
      setIdTargetTaskValue(e.target.value);
    const handleDateSurvChange = (e) => setDateSurvValue(e.target.value);
    const handleIdStateChange = (e) => setIdStateValue(e.target.value);
    const handleIdDesignSchemaChange = (e) =>
      setIdDesignSchemaValue(e.target.value);
    const handleIdDocTypeChange = (e) => setIdDocTypeValue(e.target.value);
    const handleIdSpecWorkSheetChange = (e) =>
      setIdSpecWorkSheetValue(e.target.value);
    const handleIdSpecWorkPhotoChange = (e) =>
      setIdSpecWorkPhotoValue(e.target.value);
    const handleIdSpecBuildChange = (e) => setIdSpecBuildValue(e.target.value);
    const handleIdSpecTechChange = (e) => setIdSpecTechValue(e.target.value);
    const handleIdSpecJournalChange = (e) =>
      setIdSpecJournalValue(e.target.value);
    const handleEqInstallChange = (e) => setEqInstallValue(e.target.value);
    const handleHeightTextChange = (e) => setHeightTextValue(e.target.value);
    const handleIsDocAnalyseNot2Change = (e) =>
      setIsDocAnalyseNot2Value(e.target.value);
    const handleCoordLatChange = (e) => setCoordLatValue(e.target.value);
    const handleCoordLngChange = (e) => setCoordLngValue(e.target.value);
    const handleDegLatChange = (e) => setDegLatValue(e.target.value);
    const handleDegLngChange = (e) => setDegLngValue(e.target.value);
    const handleIdBuildOrgChange = (e) => setIdBuildOrgValue(e.target.value);
    const handleConditionOperChange = (e) =>
      setConditionOperValue(e.target.value);
    const handleIsMeasuringVerifyOutToReportChange = (e) =>
      setIsMeasuringVerifyOutToReportValue(e.target.value);
    const handleIdStateConclusionChange = (e) =>
      setIdStateConclusionValue(e.target.value);
    const handleMSortPlanGraphChange = (e) =>
      setMSortPlanGraphValue(e.target.value);
    const handleIsDateSurvChange = (e) => setIsDateSurvValue(e.target.value);
    const handleDateSignConclusionChange = (e) =>
      setDateSignConclusionValue(e.target.value);
    const handleIsNotOutCategoryChange = (e) =>
      setIsNotOutCategoryValue(e.target.value);
    const handleIdSigner1Change = (e) => setIdSigner1Value(e.target.value);
    const handleIdSigner2Change = (e) => setIdSigner2Value(e.target.value);
    const handleLandImageChange = (e) => setLandImageValue(e.target.value);
    const handleIsLandingChange = (e) => setIsLandingValue(e.target.value);
    const handleLandNameChange = (e) => setLandNameValue(e.target.value);
    const handleLhPointChange = (e) => setLhPointValue(e.target.value);
    const handleRdPointChange = (e) => setRdPointValue(e.target.value);
    const handleIsPreCategoryChange = (e) =>
      setIsPreCategoryValue(e.target.value);
    const handleDateSurvNextChange = (e) =>
      setDateSurvNextValue(e.target.value);
    const handleTreeGroupNameChange = (e) =>
      setTreeGroupNameValue(e.target.value);
    const handleIsDeleteChange = (e) => setIsDeleteValue(e.target.value);

    const toggleConstructionOrg = (orgId) => {
      setSelectedConstructionOrgs((prev) =>
        prev.includes(orgId)
          ? prev.filter((id) => id !== orgId)
          : [...prev, orgId],
      );
    };

    const getSelectedConstructionOrgNames = () => {
      return selectedConstructionOrgs
        .map((id) => {
          const org = constructionOrgs.find((o) => o.Id.toString() === id);
          return org ? org.Name : "";
        })
        .filter(Boolean)
        .join(", ");
    };

    const getFormDataForSave = () => {
      const constructionOrgNamesString = getSelectedConstructionOrgNames();

      const formData = {
        idCustomer: customerId ? Number(customerId) : 0,
        Name: objectIdValue, // ID объекта - самое важное поле
        ObjName: objectNameValue || objectIdValue, // Поле "Объект", если пустое - берем ID объекта
        Cipher: cipherValue,
        Voltage: voltageValue ? parseFloat(voltageValue) : null,
        LType: lTypeValue || null, // Теперь это ObjectCType
        LDoc: regNumberValue || null,
        Mark: markValue || null,
        PageNumber: pageNumberValue || null,
        Address: addressValue,
        Year: yearValue || null,
        ResLevel: selectedPurpose,
        SurvReason: survReasonValue || null,
        idSurvOrg: 3, // Всегда 3
        NTypeRating: nTypeRatingValue || null,
        NTypeObj: nTypeObjValue || null, // Теперь это ObjectType
        idSpecWork: idSpecWorkValue || null,
        idSpecCheck: idSpecCheckValue || null,
        idSpecControl: idSpecControlValue || null,
        WorkName:
          workNameValue ||
          (selectedWork
            ? works.find((w) => w.Id.toString() === selectedWork)?.Name || ""
            : ""), // Наименование работы
        BookName: bookNameValue || null,
        Height: heightValue ? parseFloat(heightValue) : null,
        NTypeSubObj: nTypeSubObjValue || null,
        idRegion: selectedRegion || null,
        idOrgName: selectedDesigner || null,
        TypeOwn: selectedOwnershipForm,
        StateObj: stateObjValue,
        BuildYearObj: buildYearValue,
        ProjectTypeObj: projectTypeValue,
        RepairYearObj: repairYearValue,
        idTargetTask: idTargetTaskValue || null,
        DateSurv: dateSurvValue || null,
        idState: idStateValue || null,
        idOwner: selectedOwner || null,
        idDesignSchema: idDesignSchemaValue || null,
        idDocType: idDocTypeValue || null,
        idOrgStroy:
          selectedConstructionOrgs.length > 0
            ? selectedConstructionOrgs.map((id) => Number(id))
            : null,
        WorkDir: workDirValue, // Путь к папке
        idSpecWorkSheet: idSpecWorkSheetValue || null,
        idSpecWorkPhoto: idSpecWorkPhotoValue || null,
        idSpecBuild: idSpecBuildValue || null,
        idSpecTech: idSpecTechValue || null,
        idSpecJournal: idSpecJournalValue || null,
        BaseLinkObj: baseLinkValue,
        EqInstall: eqInstallValue || null,
        HeightText: heightTextValue || null,
        InputExpDate: inputExpDateValue,
        IsDocAnalyseNot2: isDocAnalyseNot2Value || null,
        CoordLat: coordLatValue ? parseFloat(coordLatValue) : null,
        CoordLng: coordLngValue ? parseFloat(coordLngValue) : null,
        DegLat: degLatValue || null,
        DegLng: degLngValue || null,
        idBuildOrg: idBuildOrgValue || null,
        PeriodTone: periodToneValue,
        ConditionOper: conditionOperValue || null,
        IsMeasuringVerifyOutToReport: isMeasuringVerifyOutToReportValue || null,
        CustomOrgName: constructionOrgNamesString || null,
        idStateConclusion: idStateConclusionValue || null,
        mSortPlanGraph: mSortPlanGraphValue || null,
        IsDateSurv: isDateSurvValue || null,
        DateSignConclusion: dateSignConclusionValue || null,
        IsNotOutCategory: isNotOutCategoryValue || null,
        idSigner1: idSigner1Value || null,
        idSigner2: idSigner2Value || null,
        ObjIdIndex: objectIndexValue,
        LandImage: landImageValue || null,
        isLanding: isLandingValue || null,
        LandName: landNameValue || null,
        LHPoint: lhPointValue || null,
        RDPoint: rdPointValue || null,
        IsPreCategory: isPreCategoryValue || null,
        FloorsNum: floorsNumValue,
        DateSurvNext: dateSurvNextValue || null,
        TreeGroupName: treeGroupNameValue || null,
        isDelete: isDeleteValue || null,
        ConstructiveScheme: constructiveSchemeValue || null,
      };

      console.log("Данные для сохранения:", formData);
      return formData;
    };

    useImperativeHandle(ref, () => ({
      save: async () => {
        if (onSave) {
          const formData = getFormDataForSave();
          await onSave(formData);
        }
      },
      getFormData: getFormDataForSave,
      refreshRegistrationNumber: fetchRegistrationNumber,
      refreshWorkdir: generateWorkdirPath,
      updateWorkDir: (newPath) => {
        setWorkDirValue(newPath);
      },
    }));

    // Опции
    const objectTypeOptions = availableObjectTypes.map((type) => ({
      value: type.ObjectID.toString(),
      label: type.ObjectName,
    }));

    console.log("Опции типов объектов:", objectTypeOptions);

    const ownershipFormOptions = [
      { value: "Государственная", label: "Государственная" },
      { value: "Частная", label: "Частная" },
      { value: "Федеральная", label: "Федеральная" },
    ];

    const purposeOptions = [
      { value: "Нормальный", label: "Нормальный" },
      { value: "Повышенный", label: "Повышенный" },
      { value: "Пониженный", label: "Пониженный" },
    ];

    const towerConstructiveSchemes = [
      "Восьмигранная",
      "Гиперболоид",
      "Трехгранная решетчатая опора",
      "Труба",
      "Четырехгранная решетчатая опора",
      "Шестигранная решетчатая опора",
    ];

    const buildingConstructiveSchemes = [
      "Не определена",
      "Бескаркасное",
      "Каркасное",
      "Каркасное железобетонное",
      "Кирпичное",
      "На кровле",
      "Не выбрана (по умолчанию)",
      "Сборный железобетон",
      "Смешанная",
    ];

    const mastConstructiveSchemes = [
      "Две ноги",
      "Одногранная",
      "Трехгранная решетчатая опора, расчалененная оттяжками",
      "Труба",
      "Труба с реями",
      "Четырехгранная решетчатая опора, расчаленная оттяжками",
    ];

    const selectedOrgNames = getSelectedConstructionOrgNames();

    // Определяем, какие поля показывать по логике объекта
    const currentObjectType =
      availableObjectTypes.find(
        (type) => type.ObjectID.toString() === selectedObjectType,
      )?.ObjectName || "";

    const showRegNumberLogic = [
      "Башня",
      "Здание",
      "Опора ВЛ",
      "Подстанция",
    ].includes(currentObjectType);
    const showConstructiveSchemeLogic = ["Башня", "Здание", "Мачта"].includes(
      currentObjectType,
    );
    const showHeightLogic = currentObjectType === "Башня";
    const showVoltageLogic = ["Опора ВЛ", "Подстанция"].includes(
      currentObjectType,
    );

    // --- НОВОЕ: Вспомогательная функция для проверки видимости ---
    const isFieldVisible = (fieldName) => {
      if (fieldSettings.isAdmin) return true; // Админ видит всё
      return fieldSettings[fieldName] === true;
    };

    if (loadingSettings) {
      return (
        <div className="text-center p-5">
          <CSpinner color="primary" />
          <div className="mt-2">Загрузка настроек полей...</div>
        </div>
      );
    }

    return (
      <CContainer
        fluid
        className="object-info-tab-container"
        style={{ position: "relative" }}
      >
        <CForm>
          <CRow className="mb-3 align-items-start">
            {/* Верхние основные поля с проверкой настроек */}

            {isFieldVisible("show_objectId") && (
              <CCol md={2}>
                <CFormLabel htmlFor="objectId" className="form-label-top">
                  Название объекта:<span className="text-danger ms-1">*</span>
                </CFormLabel>

                <CFormInput
                  type="text"
                  id="objectId"
                  value={objectIdValue}
                  onChange={handleObjectIdChange}
                  className="compact-input-top"
                  placeholder="Введите названи"
                  invalid={!!objectIdError}
                />

                {objectIdError && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "12px",
                      padding: "10px 0 0 0",
                    }}
                  >
                    {objectIdError}
                  </div>
                )}
              </CCol>
            )}

            {isFieldVisible("show_objectIndex") && (
              <CCol md={2}>
                <CFormLabel htmlFor="objectIndex" className="form-label-top">
                  Индекс ID объекта:
                </CFormLabel>
                <CFormInput
                  type="text"
                  id="objectIndex"
                  value={objectIndexValue}
                  onChange={handleObjectIndexChange}
                  className="compact-input-top"
                />
              </CCol>
            )}

            {isFieldVisible("show_objectType") && (
              <CCol md={2}>
                <CFormLabel htmlFor="objectType" className="form-label-top">
                  Тип сооружения:
                </CFormLabel>
                <CFormSelect
                  id="objectType"
                  value={selectedObjectType}
                  onChange={handleObjectTypeChange}
                  className="compact-select-top"
                >
                  <option value="">Выберите тип</option>
                  {objectTypeOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </CFormSelect>
              </CCol>
            )}

            {isFieldVisible("show_objectName") && (
              <CCol md={2}>
                <CFormLabel htmlFor="objectName" className="form-label-top">
                  Объект:
                </CFormLabel>
                <CFormInput
                  type="text"
                  id="objectName"
                  value={objectNameValue}
                  onChange={handleObjectNameChange}
                  className="compact-input-top"
                  readOnly={true}
                  placeholder="Автоматически"
                />
              </CCol>
            )}

            {isFieldVisible("show_regNumber") && showRegNumberLogic && (
              <CCol md={2}>
                <CFormLabel htmlFor="regNumber" className="form-label-top">
                  Регистр. номер:<span className="text-danger ms-1">*</span>
                </CFormLabel>
                <CFormInput
                  type="text"
                  id="regNumber"
                  value={regNumberValue || ""}
                  onChange={handleRegNumberChange}
                  className="compact-input-top"
                  readOnly={true}
                  disabled={regNumberLoading}
                />
              </CCol>
            )}

            {isFieldVisible("show_constructiveScheme") &&
              showConstructiveSchemeLogic && (
                <CCol md={2}>
                  <CFormLabel
                    htmlFor="constructiveScheme"
                    className="form-label-top"
                  >
                    Конструктивная схема:
                  </CFormLabel>
                  <CFormSelect
                    id="constructiveScheme"
                    value={constructiveSchemeValue}
                    onChange={handleConstructiveSchemeChange}
                    className="compact-select-top"
                  >
                    <option value="">Выберите схему</option>
                    {(currentObjectType === "Башня"
                      ? towerConstructiveSchemes
                      : currentObjectType === "Здание"
                        ? buildingConstructiveSchemes
                        : mastConstructiveSchemes
                    ).map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </CFormSelect>
                </CCol>
              )}

            {isFieldVisible("show_height") && showHeightLogic && (
              <CCol md={2}>
                <CFormLabel htmlFor="height" className="form-label-top">
                  Высота:
                </CFormLabel>
                <CFormInput
                  type="number"
                  id="height"
                  value={heightValue}
                  onChange={handleHeightChange}
                  className="compact-input-top"
                  step="1"
                  min="100"
                />
              </CCol>
            )}

            {isFieldVisible("show_voltage") && showVoltageLogic && (
              <CCol md={2}>
                <CFormLabel htmlFor="voltage" className="form-label-top">
                  Напряжение, кВ:
                </CFormLabel>
                <CFormInput
                  type="number"
                  id="voltage"
                  value={voltageValue}
                  onChange={handleVoltageChange}
                  className="compact-input-top"
                  step="1"
                  min="100"
                />
              </CCol>
            )}
          </CRow>

          <div className="object-info-list-wrapper">
            {[
              {
                setting: "show_region",
                label: "Регион:",
                value: selectedRegion,
                isSelect: true,
                options: regions.map((r) => ({
                  value: r.Id.toString(),
                  label: r.Name,
                })),
                selectValue: selectedRegion,
                onChange: handleRegionChange,
                loading: loadingRegions,
              },
              {
                setting: "show_address",
                label: "Адрес объекта:",
                value: addressValue,
                onChange: handleAddressChange,
              },
              {
                setting: "show_owner",
                label: "Собственник объекта:",
                value: selectedOwner,
                isSelect: true,
                options: owners.map((o) => ({
                  value: o.Id.toString(),
                  label: o.Name,
                })),
                selectValue: selectedOwner,
                onChange: handleOwnerChange,
                loading: loadingOwners,
              },
              {
                setting: "show_ownershipForm",
                label: "Форма собственности объекта:",
                value: selectedOwnershipForm,
                isSelect: true,
                options: ownershipFormOptions,
                selectValue: selectedOwnershipForm,
                onChange: handleOwnershipFormChange,
              },
              {
                setting: "show_objectStatus",
                label: (
                  <CTooltip
                    content="Памятник архитектуры и т.д."
                    placement="right"
                  >
                    <span className="tooltip-label">Статус объекта</span>
                  </CTooltip>
                ),
                value: stateObjValue,
                onChange: handleStateObjChange,
              },
              {
                setting: "show_buildYear",
                label: "Год возведения объекта:",
                value: buildYearValue,
                onChange: handleBuildYearChange,
              },
              {
                setting: "show_inputExpDate",
                label: "Год ввода в эксплуатацию:",
                value: inputExpDateValue,
                onChange: handleInputExpDateChange,
              },
              {
                setting: "show_projectType",
                label: "Тип проекта объекта:",
                value: projectTypeValue,
                onChange: handleProjectTypeChange,
              },
              {
                setting: "show_designer",
                label: "Разработчик проектной документации:",
                value: selectedDesigner,
                isSelect: true,
                options: designers.map((d) => ({
                  value: d.Id.toString(),
                  label: d.Name,
                })),
                selectValue: selectedDesigner,
                onChange: handleDesignerChange,
                loading: loadingDesigners,
              },
              {
                setting: "show_constructionOrg",
                label: "Строительная организация, возводившая объект:",
                render: () => (
                  <CFormInput
                    type="text"
                    value={getSelectedConstructionOrgNames()}
                    readOnly
                    onClick={() => setShowConstructionOrgPicker(true)}
                    ref={inputRef}
                    className="info-input"
                  />
                ),
              },
              {
                setting: "show_repairYear",
                label:
                  "Год и характер выполнения последнего капитального ремонта:",
                value: repairYearValue,
                onChange: handleRepairYearChange,
              },
              {
                setting: "show_responsibilityLevel",
                label: "Назначение сооружения/уровень ответственности:",
                value: selectedPurpose,
                isSelect: true,
                options: purposeOptions,
                selectValue: selectedPurpose,
                onChange: handlePurposeChange,
              },
              {
                setting: "show_floorsNum",
                label: "Число этажей, секций:",
                value: floorsNumValue,
                onChange: handleFloorsNumChange,
              },
              {
                setting: "show_periodTone",
                label: "Период основного тона собственных колебаний, с:",
                value: periodToneValue,
                onChange: handlePeriodToneChange,
              },
              {
                setting: "show_workName",
                label: (
                  <>
                    Наименование работы:
                    <span className="text-danger ms-1">*</span>
                  </>
                ),
                value: selectedWork,
                isSelect: true,
                options: works.map((w) => ({
                  value: w.Id.toString(),
                  label: w.Name,
                })),
                selectValue: selectedWork,
                onChange: handleWorkChange,
                loading: loadingWorks,
              },
              {
                setting: "show_conditionalDesignation",
                label: "Условное обозначение:",
                value: conditionalDesignationValue,
                onChange: handleConditionalDesignationChange,
              },
              {
                setting: "show_cipher",
                label: "Шифр проекта:",
                value: cipherValue,
                onChange: handleCipherChange,
              },
              {
                setting: "show_baseLink",
                label: "Ссылка на базовый объект:",
                value: baseLinkValue,
                onChange: handleBaseLinkChange,
              },
              {
                setting: "show_workDir",
                label: (
                  <div className="d-flex align-items-center">
                    <span>
                      Путь к папке:<span className="text-danger ms-1">*</span>
                    </span>
                    {isGeneratingWorkdir && (
                      <CSpinner size="sm" className="ms-2" />
                    )}
                  </div>
                ),
                render: () => (
                  <CFormInput
                    type="text"
                    value={workDirValue}
                    readOnly={true}
                    className="info-input"
                  />
                ),
              },
            ].map((item, index) => {
              // ФИЛЬТРАЦИЯ ПО НАСТРОЙКАМ
              if (!isFieldVisible(item.setting)) return null;

              return (
                <CRow key={index} className="object-info-item mb-1">
                  <CCol xs={5} className="label-col">
                    <CFormLabel className="object-info-label">
                      {item.label}
                    </CFormLabel>
                  </CCol>
                  <CCol xs={7} className="value-col">
                    {item.render ? (
                      item.render()
                    ) : item.isSelect ? (
                      <CFormSelect
                        value={item.selectValue || ""}
                        onChange={item.onChange}
                        className="info-input"
                        disabled={item.loading}
                      >
                        <option value=""></option>
                        {item.options.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </CFormSelect>
                    ) : (
                      <CFormInput
                        type="text"
                        value={item.value}
                        onChange={item.onChange}
                        className="info-input"
                        placeholder={item.placeholder}
                      />
                    )}
                  </CCol>
                </CRow>
              );
            })}
          </div>

          {showConstructionOrgPicker && (
            <div
              ref={pickerRef}
              style={{
                position: "fixed",
                top: `${pickerPosition.top}px`,
                left: `${pickerPosition.left}px`,
                background: "#fff",
                border: "1px solid #d1d5db",
                borderRadius: "6px",
                boxShadow:
                  "0 10px 25px -5px rgba(0,0,0,0.1), 0 8px 10px -6px rgba(0,0,0,0.1)",
                zIndex: 1050,
                minWidth: "280px",
                maxHeight: "320px",
                overflow: "hidden",
                fontSize: "0.875rem",
              }}
            >
              <div
                style={{
                  maxHeight: "270px",
                  overflowY: "auto",
                  padding: "10px",
                }}
              >
                {constructionOrgs.length === 0 ? (
                  <div style={{ padding: "8px", color: "#666" }}>
                    Нет данных
                  </div>
                ) : (
                  constructionOrgs.map((org) => (
                    <CFormCheck
                      key={org.Id}
                      id={`org-${org.Id}`}
                      label={org.Name}
                      checked={selectedConstructionOrgs.includes(
                        org.Id.toString(),
                      )}
                      onChange={() => toggleConstructionOrg(org.Id.toString())}
                      style={{ marginBottom: "6px" }}
                    />
                  ))
                )}
              </div>
              <div
                style={{
                  textAlign: "right",
                  padding: "6px 10px",
                  borderTop: "1px solid #eee",
                }}
              >
                <CButton
                  size="sm"
                  color="light"
                  onClick={() => setShowConstructionOrgPicker(false)}
                  style={{ fontSize: "0.75rem", padding: "2px 6px" }}
                >
                  Закрыть
                </CButton>
              </div>
            </div>
          )}
        </CForm>
      </CContainer>
    );
  },
);

ObjectInfoTab.propTypes = {
  initialObjectId: PropTypes.string,
  initialObjectType: PropTypes.string,
  availableObjectTypes: PropTypes.arrayOf(
    PropTypes.shape({
      ObjectID: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
      ObjectName: PropTypes.string.isRequired,
      Description: PropTypes.string,
      ObjectType: PropTypes.number,
      ObjectIcon: PropTypes.string,
      ObjectCType: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
  ).isRequired,
  onSave: PropTypes.func,
  customerId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  selectedObjectTypeFromModal: PropTypes.shape({
    ObjectID: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    ObjectName: PropTypes.string,
    ObjectType: PropTypes.number,
    ObjectCType: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
};

ObjectInfoTab.defaultProps = {
  initialObjectId: "",
  initialObjectType: "",
  availableObjectTypes: [],
  onSave: null,
  customerId: null,
  selectedObjectTypeFromModal: null,
};

export default ObjectInfoTab;
